import React, { useState, useEffect } from "react";
import Footer from "../components/Footer";
import { createClient } from "contentful";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { useParams } from "react-router-dom";
import moment from "moment";

const BlogPage = () => {
  const [blogPost, setBlogPost] = useState([]);

  const { id } = useParams();
  const client = createClient({
    space: process.env.REACT_APP_SPACE_ID,
    accessToken: process.env.REACT_APP_ACCESS_TOKEN,
  });

  useEffect(() => {
    const getEntry = async () => {
      try {
        await client.getEntry(id).then((entry) => {
          console.log(entry);
          setBlogPost(entry);
        });
      } catch (error) {
        console.log(error);
      }
    };

    getEntry();
  }, [id, client]);
  return (
    <div className="w-100">
      <div className="w-100  md:max-w-[960px] mx-auto md:py-5 ">
        <div className="h-80 w-100 bg-black relative bg-gradient-to-b from-gray-400 to-gray-900">
          <img
            className="w-full h-full object-cover absolute mix-blend-overlay"
            src={blogPost?.fields?.featuredImage?.fields?.file?.url}
            alt=""
          />

          <div className="px-5 md:px-10">
            <div className="pt-48">
              <h1 className="text-slate-100 text-xl md:text-3xl font-semibold md:font-bold mb-4">
                {blogPost?.fields?.title}
              </h1>

              <div>
                <p className="text-sm text-slate-300 font-semibold  md:text-xl mb-2">
                  By: {blogPost?.fields?.author}
                </p>
                <p className="text-sm text-slate-200 font-normal">
                  {moment(blogPost?.fields?.createdOn).format("Do MMMM YYYY")}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="w-100  md:max-w-[960px] mx-auto  ">
          <div className="py-8 px-3">
            <p className="text-sm md:text-lg leading-loose">
              {documentToReactComponents(blogPost?.fields?.post)}
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default BlogPage;
